export default __webpack_public_path__ + "static/media/check-circle.3b7902b3.svg";